import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="leftbar-scroll"
export default class extends Controller {
  static targets = ["scrollContainer"];
  static values = {
    storageKey: { type: String, default: "leftbar-scroll-position" },
  };

  connect() {
    // Bind the methods to preserve context
    this.boundSaveScrollPosition = this.saveScrollPosition.bind(this);
    this.boundRestoreScrollPosition = this.restoreScrollPosition.bind(this);

    // Restore scroll position on page load
    this.restoreScrollPosition();

    // Listen for Turbo navigation events
    document.addEventListener(
      "turbo:before-visit",
      this.boundSaveScrollPosition
    );
    document.addEventListener("turbo:load", this.boundRestoreScrollPosition);
    document.addEventListener(
      "turbo:before-stream-render",
      this.boundSaveScrollPosition
    );

    // Also save on beforeunload as fallback
    window.addEventListener("beforeunload", this.boundSaveScrollPosition);
  }

  disconnect() {
    // Clean up event listeners
    if (this.boundSaveScrollPosition) {
      document.removeEventListener(
        "turbo:before-visit",
        this.boundSaveScrollPosition
      );
      document.removeEventListener(
        "turbo:load",
        this.boundRestoreScrollPosition
      );
      document.removeEventListener(
        "turbo:before-stream-render",
        this.boundSaveScrollPosition
      );
      window.removeEventListener("beforeunload", this.boundSaveScrollPosition);
    }
  }

  saveScrollPosition() {
    const scrollContainer = this.scrollContainerTarget;
    if (scrollContainer) {
      const scrollPosition = scrollContainer.scrollTop;
      sessionStorage.setItem(this.storageKeyValue, scrollPosition.toString());
    }
  }

  restoreScrollPosition() {
    // Use requestAnimationFrame to ensure the DOM is ready
    requestAnimationFrame(() => {
      const savedPosition = sessionStorage.getItem(this.storageKeyValue);
      if (savedPosition && this.hasScrollContainerTarget) {
        const position = parseInt(savedPosition, 10);
        if (position > 0) {
          this.scrollContainerTarget.scrollTop = position;
        }
      }
    });
  }

  // Method to manually save position when clicking on links
  handleLinkClick() {
    this.saveScrollPosition();
  }
}
